<template>
  <div class="common-list-wrapper">
    <el-scrollbar ref="scrollbar">
      <div class="common-list" id="js-common-list">
        <slot name="listContent"></slot>
      </div>
    </el-scrollbar>
    <elPagination class="page-component" v-if="showFoot" :layout="'prev, pager, next'" :total="totalCount" :pageSize="pageSize" @handleCurrentChange="flipPage" :currentPage="currentPage">
      <slot>
        共<span class="text-yellow">{{ totalCount }}</span
        >条记录
      </slot>
    </elPagination>
  </div>
</template>

<script>
import elPagination from '@components/common/elPagination.vue'

export default {
  name: 'listFrame',
  data() {
    return {
      scrollDom: null
    }
  },
  props: {
    totalCount: [Number, String],
    currentPage: [Number, String],
    showFoot: {
      type: Boolean,
      default: true
    },
    pageSize: { default: 11 }
  },
  methods: {
    add() {
      this.$emit('add')
    },
    flipPage(val) {
      if (this.scrollDom != null) {
        if (this.scrollDom.scrollTop > 0) {
          this.scrollDom.scrollTop = 0
        }
      }
      this.$emit('flipPage', val)
    }
  },
  components: {
    elPagination
  },
  mounted() {
    this.scrollDom = document.getElementById('js-common-list')
  }
}
</script>

<style lang="scss" scoped>
.common-list-wrapper {
  .common-list {
    padding-top: 16px;
    height: calc(100vh - 240px);
    min-height: 360px;
    overflow-y: auto;
  }
  .page-component {
    margin-top: 10px;
  }
}
</style>
